import React from 'react';
import { connect } from 'react-redux';
import { link_click } from '../../../redux/actions';
import ReportLauncherPage from '../../ReportLauncher/ReportLauncherPage';
import buildCorporateOfficeFinanceReportsSections from './CorporateOfficeFinanceReportsSections';

class CorporateOfficeFinanceReportsAdmin extends React.Component {
  render() {
    return <ReportLauncherPage sections={buildCorporateOfficeFinanceReportsSections(this.props.link_click)} />;
  }
}

export default connect(null, { link_click })(CorporateOfficeFinanceReportsAdmin);
